export default class FileUtils {
  //  ****************
  //  ** Attributes **
  //  ****************
  static maxWidth = 1270;
  static maxHeight = 720;

  // *************
  // ** Methods **
  // *************
  static scaleImage(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        const image = new Image();
        image.src = event.target.result;

        image.onload = () => {
          try {
            const shouldResizeImage = image.width > this.maxWidth || image.height > this.maxHeight;
            if (!shouldResizeImage) {
              return resolve(file);
            }

            // ***---- Resizing Image ----***
            const aspectRatio = image.width / image.height;
            let scaledWidth = image.width;
            let scaledHeight = image.height;

            if (scaledWidth > this.maxWidth) {
              scaledWidth = this.maxWidth;
              scaledHeight = Math.round(scaledWidth / aspectRatio);
            }

            if (scaledHeight > this.maxHeight) {
              scaledHeight = this.maxHeight;
              scaledWidth = Math.round(scaledHeight * aspectRatio);
            }

            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");

            canvas.width = scaledWidth;
            canvas.height = scaledHeight;
            context.drawImage(image, 0, 0, scaledWidth, scaledHeight);

            canvas.toBlob((blob) => {
              if (blob) {
                const resizedImage = new File([blob], file.name, { type: file.type, lastModified: Date.now() });
                resolve(resizedImage);
              } else {
                reject(new Error("Failed to create blob from canvas!"));
              }
            }, file.type, 1.00);
          } catch (exception) {
            reject(exception);
          }
        };

        image.onerror = () => reject(new Error("Failed to load image!"));
      };

      reader.onerror = () => reject(new Error("Failed to read image!"));

      reader.readAsDataURL(file);
    });
  }
}
